var fileFields = document.querySelectorAll('.c-file-field');

Array.prototype.forEach.call(fileFields, function(fileField) {
    var label = fileField.nextElementSibling;
    var labelValue = label.innerHTML;

    fileField.addEventListener('change', function(event) {
        var fileName = event.target.value.split('\\').pop();

        if (fileName) {
            label.querySelector('span').innerHTML = (fileName.length > 15) ? fileName.slice(0, 12) + '...' : fileName;
        } else {
            label.innerHTML = labelValue;
        }
    });

    fileField.addEventListener('focus', function() {
        fileField.classList.add('focus');
    });

    fileField.addEventListener('blur', function() {
        fileField.classList.remove('focus');
    });
});
